<div class="container-fluid pl-0 pr-0">
  <div class="modal-header">
    <div class="col-xs-11 col-md-11">
      <h4 class="modal-title fw-bold word-wrap">{{ 'brapi-sync.germplasm-pedigree-graph-modal.title' | translate }}</h4>
      <span>{{sourceGermplasm.germplasmName}} (ID: {{sourceGermplasm.germplasmDbId}})</span>
    </div>
    <button type="button" class="btn-close" data-dismiss="modal" aria-hidden="true"
      (click)="clear()">
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col">
                <div class="legend-title">{{ 'brapi-sync.germplasm-pedigree-graph-modal.legend.title' | translate }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <div class="node-legend">
                  <div class="legend-scale">
                    <ul class="legend-labels">
                      <li><div class="box no-border" style="color:Red">&#8212;&#8212;&#8212;</div><span>{{ 'brapi-sync.germplasm-pedigree-graph-modal.legend.female-parent' | translate }}</span></li>
                      <li><div class="box no-border" style="color:Blue">&#8212;&#8212;&#8212;</div><span>{{ 'brapi-sync.germplasm-pedigree-graph-modal.legend.male-parent' | translate }}</span></li>
                      <li><div class="box no-border" style="color:Black">&#8212;&#8212;&#8212;</div><span>{{ 'brapi-sync.germplasm-pedigree-graph-modal.legend.derivative-self' | translate }}</span></li>
                    </ul>
                  </div>
                </div>
              </div>
              @if (showDestinationPreviewTree) {
                <div class="col-5">
                  <div class="node-legend">
                    <div class="legend-scale">
                      <ul class="legend-labels">
                        <li><div class="box gold"></div><span>{{ 'brapi-sync.germplasm-pedigree-graph-modal.legend.already-exists' | translate }}</span></li>
                        <li><div class="box lime-green"></div><span>{{ 'brapi-sync.germplasm-pedigree-graph-modal.legend.no-existing-record' | translate }}</span></li>
                        <li><div class="box red"></div><span>{{ 'brapi-sync.germplasm-pedigree-graph-modal.legend.parent-not-match' | translate }}</span></li>
                      </ul>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
      @if (showDestinationPreviewTree) {
        <div class="row">
          <div class="col">
            <div class="form-check form-switch">
              <input type="checkbox" class="form-check-input" name="showSourcePedigreeTreeCheckbox" id="showSourcePedigreeTreeCheckbox" [(ngModel)]="showSourcePedigreeTree">
              <label class="custom-control-label" for="showSourcePedigreeTreeCheckbox">{{ 'brapi-sync.germplasm-pedigree-graph-modal.show-source-pedigree-tree' | translate }}</label>
            </div>
          </div>
        </div>
      }
      <div class="row">
        @if (showSourcePedigreeTree) {
          <div [ngClass]="showSourcePedigreeTree && !showDestinationPreviewTree ? 'col' : 'col-6'">
            <p class="text-center fw-bold">{{ 'brapi-sync.germplasm-pedigree-graph-modal.source-pedigree-tree' | translate }}</p>
          </div>
        }
        @if (showDestinationPreviewTree) {
          <div [ngClass]="!showSourcePedigreeTree && showDestinationPreviewTree ? 'col' : 'col-6'">
            <p class="text-center fw-bold">{{ 'brapi-sync.germplasm-pedigree-graph-modal.preview-destination-pedigree-tree' | translate }}</p>
          </div>
        }
      </div>
      <div class="row">
        @if (showSourcePedigreeTree) {
          <div [ngClass]="showSourcePedigreeTree && !showDestinationPreviewTree ? 'col' : 'col-6'">
            <app-pedigree-graph [graphId]="'graphSource'" [isPreviewTarget]="false" [getGermplasmTreeNode]="getGermplasmTreeNode.bind(this)" [colorizeNodes]="false"></app-pedigree-graph>
          </div>
        }
        @if (showDestinationPreviewTree) {
          <div [ngClass]="!showSourcePedigreeTree && showDestinationPreviewTree ? 'col' : 'col-6'">
            <app-pedigree-graph [graphId]="'graphDestination'" [isPreviewTarget]="true" [getGermplasmTreeNode]="getGermplasmTreeNode.bind(this)" [colorizeNodes]="true"></app-pedigree-graph>
          </div>
        }
      </div>
    </div>
  </div>
